(function($) {
    $(function() {
        $('body').on('click', '.popover-close', function(event) {
            $(event.target).closest('[popover]').each(function(_index, element) {
                element.togglePopover();
            });
        });
    });
})(window.jQuery);
